module.exports = __webpack_public_path__ + "img/distribuitor_autorizat.a7ba7fda.svg";